export default "__VITE_ASSET__DvVig7nP__"